var _defs, _path, _path2, _path3, _path4, _path5, _path6, _mask, _use, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227,
    height: 152,
    viewBox: "0 0 227 152"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__a",
    x1: "50%",
    x2: "96.179%",
    y1: "51.149%",
    y2: "49.221%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#405AA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#051932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__b",
    x1: "-14.578%",
    x2: "96.179%",
    y1: "52.663%",
    y2: "45.527%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#536DB5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E284B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__d",
    x1: "15.032%",
    x2: "61.33%",
    y1: "106.609%",
    y2: "20.42%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A5A0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#302C48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__e",
    x1: "18.543%",
    x2: "66.058%",
    y1: "78.7%",
    y2: "78.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5CFBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__f",
    x1: "37.202%",
    x2: "50%",
    y1: "-7.956%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F4B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F47E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__g",
    x1: "45.497%",
    x2: "53.857%",
    y1: "60.159%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9EDC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6D993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__i",
    x1: "0%",
    x2: "100%",
    y1: "54.466%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D797BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E6A0C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__k",
    x1: "45.417%",
    x2: "53.925%",
    y1: "60.159%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2E5BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0D38A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-available_svg__l",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "99.509%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7C8F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3B495A"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "not-available_svg__c",
    cx: 78.5,
    cy: 118.504,
    rx: 6.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "not-available_svg__h",
    d: "M10 0h14.173c5.523 0 10 4.477 10 10v6.839H0V10C0 4.477 4.477 0 10 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8692AC",
    fillOpacity: 0.44,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M88.047 125.479l52.037-15.372 49.565 21.901-95.6 19.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8692AC",
    fillOpacity: 0.28,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 112.316l59.733-3.973 54.261.981-85.505 18.129z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF3F9",
    fillRule: "nonzero",
    d: "M3.071 97.503c5.008 13.794 10.47 22.337 16.388 25.63 20.57 11.447 37.66 19.938 51.27 25.473 19.483 7.924 35.64 1.989 48.472-17.806 33.231 5.369 58.32 5.369 75.268 0 5.18-1.64 16.024-6.338 32.531-14.093L110.803 66.004c-9.662 14.572-19.898 23.691-30.707 27.357-6.873 2.33-28.342 9.621-53.965 9.621-7.768 0-15.454-1.826-23.06-5.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D717F",
    strokeWidth: 5,
    d: "M76.152 131.227c.14-1.326 20.139-1.788 8.252-7.465-7.924-3.785-5.018-6.604 8.72-8.457"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__a)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M227 118.004l-135-1.552 37.44-11.448 91.604 7.533z",
    transform: "matrix(-1 0 0 1 319 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 157 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-available_svg__b)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#not-available_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    style: {
      mixBlendMode: "darken"
    },
    xlinkHref: "#not-available_svg__c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__d)",
    d: "M73.869 114.647l4.31-7.298-.125-1.478-1.607-.855-2.768.613-1.892-.706-1.728.505-1.46-.852-1.274.701-.313 2.01 3.32 7.182a1.998 1.998 0 003.537.178z",
    transform: "rotate(133 72.595 111.253)"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__e)",
    d: "M21.578 113.892l12.595-22.269v-7.186H0v7.186l12.563 22.213-.498-2.774 1.611 2.515.949-3.702 1.622 3.742 1.472-2.149 2.101 2.333 1.512-2.64z",
    transform: "rotate(42 49.39 207.579)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__f)",
    d: "M0 15.848h34.173v75.775c-2.135-2.601-4.192-3.88-6.17-3.835-1.977.045-3.91 1.323-5.8 3.835-1.776-1.28-3.521-1.94-5.237-1.981-1.715-.042-3.431.618-5.148 1.98-2.32-2.97-4.412-4.457-6.273-4.457-1.86 0-3.71 1.486-5.545 4.458V15.848z",
    transform: "rotate(42 49.39 207.579)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__g)",
    d: "M0 15.848h11.886v75.775c-2.191-1.321-4.242-1.981-6.153-1.981-1.911 0-3.822.66-5.733 1.98V15.849z",
    transform: "rotate(42 49.39 207.579)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(42 49.39 207.579)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "not-available_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#not-available_svg__h"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-available_svg__i)",
    xlinkHref: "#not-available_svg__h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC2E1",
    fillOpacity: 0.403,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M21.917-3.068h12.055V20.21H21.917z",
    mask: "url(#not-available_svg__j)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-available_svg__k)",
    d: "M22.287 16.51h11.886v75.113c-1.907-1.31-3.864-1.964-5.87-1.964-2.005 0-4.01.654-6.016 1.964V16.51z",
    transform: "rotate(42 49.39 207.579)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#not-available_svg__l)",
    fillRule: "nonzero",
    opacity: 0.5,
    transform: "rotate(28 72.835 292.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.766 9.711L11.67 3.727a1.257 1.257 0 00-1.709-.54 1.288 1.288 0 00-.534 1.73l3.095 5.984c.325.627 1.09.87 1.71.54a1.29 1.29 0 00.534-1.73zM7.723 15.283L2.46 11.077a1.257 1.257 0 00-1.781.2 1.29 1.29 0 00.215 1.798l5.262 4.208c.552.442 1.35.352 1.782-.201a1.29 1.29 0 00-.216-1.798zM22.666 8.52l.311-6.73a1.258 1.258 0 00-1.21-1.323A1.29 1.29 0 0020.439 1.7l-.312 6.73a1.258 1.258 0 001.211 1.322 1.29 1.29 0 001.328-1.231z"
  })))));
}
export default SvgNotAvailable;